import * as actionTypes from "../actionTypes";
import { updateObject } from "../../shared/utility";

const initialState = {
    languages: null,
    error: null,
    loading: false,
};

// getProfile
const getLanguagesStart = (state: any, action: any) => {
    return updateObject(state, { error: null, loading: true });
};

const getLanguagesSuccess = (state: any, action: any) => {    
    return updateObject(state, {
        languages: action.languages,
        error: null,
        loading: false,
    });
};

const getLanguagesFailed = (state: any, action: any) => {
    return updateObject(state, {
        error: action.error,
        loading: false,
        languages: null
    });
};

export const setLanguagesFailed = (state: any, action: any) => {
    return updateObject(state, {
        error: action.error,
        loading: false,
    });
  };

const languageReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.GET_LANGUAGES_START:
            return getLanguagesStart(state, action);
        case actionTypes.GET_LANGUAGES_SUCCESS:
            return getLanguagesSuccess(state, action);
        case actionTypes.GET_LANGUAGES_FAIL:
            return getLanguagesFailed(state, action);
        case actionTypes.SET_LANGUAGES_FAIL:
            return  setLanguagesFailed(state, action);
        default:
            return state;
    }
};

export default languageReducer;